'use client';
import { DidomiSDK } from '@didomi/react';

export function DidomiApi() {
  /**
   * a2c599a8-8714-4b35-a7ba-1f7715531918","zxA3hNd6"
   */
  const noticeIdPl = 'zxA3hNd6';
  const noticeIdFr = 'BhYiTEyY';
  const apiKeyFr = '3497a647-256d-4aa1-8e29-6eb95cbec854';

  return (
    <DidomiSDK
      iabVersion={2}
      gdprAppliesGlobally
      apiKey={apiKeyFr}
      noticeId={noticeIdFr}
      sdkPath="https://sdk.privacy-center.org/"
      config={{
        cookies: {
          storageSources: {
            cookies: true,
            localstorage: false,
          },
        },
        tagManager: {
          provider: 'tealium|gtm',
        },
        integrations: {
          vendors: {
            google: {
              enable: true,
              eprivacy: true,
            },
          },
        },
      }}
    />
  );
}
